export const STORAGE_KEYS = {
  progress: 'geosport:progress',
  practiceProgress: 'geosport:practice-progress',
  practiceResults: 'geosport:practice-results',
  settings: 'geosport:settings',
  player: 'geosport:player',
  localState: 'geosport:local-backend',
  /** Editor's admin token for /admin (only on the editor's own device). */
  admin: 'geosport:admin-token',
  /** Daily reminder time on this device, and when the subscription was last refreshed. */
  reminder: 'geosport:reminder',
} as const;

/** localStorage can throw (private mode, quota); every access is guarded. */
export function readJson<T>(key: string, guard: (v: unknown) => v is T): T | null {
  try {
    const raw = window.localStorage.getItem(key);
    if (raw === null) return null;
    const parsed: unknown = JSON.parse(raw);
    return guard(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function readString(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore */
  }
}

export function writeString(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

export function removeKey(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

/** Forget everything this site stored in the browser (identity, progress, settings). */
export function clearAllStorage(): void {
  for (const key of Object.values(STORAGE_KEYS)) removeKey(key);
  removeKey(`${STORAGE_KEYS.settings}:name`);
}

export const isRecord = (v: unknown): v is Record<string, unknown> =>
  typeof v === 'object' && v !== null && !Array.isArray(v);
